import MainRepository from "../repository/MainRepository";
import { Httpcommon } from "../core/services/Httpcommon";
import {
  TokenResult,
  TokenRequest,
  InvoiceResult,
  ViewPaymentRequest,
  ViewPaymentResult,
} from "../domain/entity/Main";
import { Httpscommon } from "../core/services/Httpscommon";
import { Httpimage } from "../core/services/Httpimage";
import { Buffer } from 'buffer';

const getInvoiceId = () => localStorage.getItem("invoiceId") || "";

export default class MainApi implements MainRepository {
  async getToken(body: TokenRequest): Promise<TokenResult> {
    return await Httpcommon.post<TokenResult>(`/token`, {
      grantType: body.grantType,
    }).then((res) => res.data);
  }

  async getInvoice(): Promise<InvoiceResult> {
    return await Httpscommon.get<InvoiceResult>(`/detail`).then(
      (res) => res.data
    );
  }

  async getViewPayment(body: ViewPaymentRequest): Promise<ViewPaymentResult> {
    return await Httpscommon.post<ViewPaymentResult>(`/payment`, {
      ...body,
    }).then((res) => res.data);
  }

  async download(): Promise<any> {
    return await Httpscommon.get<any>(`/download`, {
      responseType: "blob",
    }).then((res) => {
      // console.log('res', JSON.stringify(res))
      // Extract filename from the Content-Disposition header
      const contentDisposition = res.headers["content-disposition"];
      let filename = getInvoiceId().toString() + '.pdf'; // Default filename

      if (contentDisposition && contentDisposition.includes("filename=")) {
        filename = contentDisposition
          .split("filename=")[1]
          .split(";")[0]
          .replace(/['"]/g, ""); // Remove any quotes around the filename
      }
      return { data: res.data, filename };
    });
  }

  async getImagePath(path: string): Promise<any> {
    return await Httpimage.get<any>(`image`, {
      params: { path: path },
      responseType: "arraybuffer",
    }).then(
      (res) =>
        `data:${res.headers["content-type"]};base64,${Buffer.from(
          res.data,
          "binary"
        ).toString("base64")}`
    );
  }
}
